"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableEmitter = exports.default = void 0;
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = require("react");
var _useAntdResizableHeader = require("use-antd-resizable-header");
var _eventEmitter = require("../_util/eventEmitter");
var _useConfig = require("../hooks/useConfig");
var _skeleton = _interopRequireDefault(require("../skeleton"));
var _spin = require("../spin/spin");
var _selection = _interopRequireDefault(require("./selection"));
require("use-antd-resizable-header/dist/style.css");
var _jsxRuntime = require("react/jsx-runtime");
const tableEmitter = exports.tableEmitter = new _eventEmitter.EventEmitter();
function TableRender(props) {
  const {
    dataSource = [],
    selection,
    rowKey,
    loading,
    columns,
    noHover,
    rowClassName,
    resizeable,
    prefixClass = 'zen-design',
    //TODO: 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const [tableKey, setTableKey] = (0, _react.useState)(0);
  let resizeableTable = {};
  if (resizeable) {
    const {
      components,
      resizableColumns,
      tableWidth,
      resetColumns
    } = (0, _useAntdResizableHeader.useAntdResizableHeader)({
      columns: (0, _react.useMemo)(() => columns, [columns]),
      // 保存拖拽宽度至本地localStorage
      columnsState: {
        persistenceKey: "resizeableTable-".concat(location.pathname),
        persistenceType: "localStorage"
      },
      onResizeEnd() {
        setTableKey(Math.random());
      }
    });
    resizeableTable = {
      columns: resizableColumns === null || resizableColumns === void 0 ? void 0 : resizableColumns.filter(i => i.hidden !== true).map(i => ({
        ...i,
        className: (0, _classnames.default)(i.className, {
          ["align-".concat(i.align)]: !!i.align
        })
      })),
      components: components,
      scroll: {
        x: tableWidth
      },
      resetColumns
    };
  }
  (0, _react.useEffect)(() => {
    const eventHandler = () => {
      var _resizeableTable, _resizeableTable$rese;
      (_resizeableTable = resizeableTable) === null || _resizeableTable === void 0 || (_resizeableTable$rese = _resizeableTable.resetColumns) === null || _resizeableTable$rese === void 0 || _resizeableTable$rese.call(_resizeableTable);
      setTimeout(() => {
        var _window;
        localStorage.removeItem("resizeableTable-".concat(location.pathname));
        (_window = window) === null || _window === void 0 || (_window = _window.navigation) === null || _window === void 0 || _window.reload();
      });
    };
    tableEmitter.on('reset-table-size', eventHandler);
    return () => {
      tableEmitter.off('reset-table-size', eventHandler);
    };
  }, []);
  const {
    locale: {
      Table: TableLocale
    }
  } = (0, _useConfig.useConfig)();
  const baseClassName = "".concat(prefixClass, "-table");
  const spinClassName = "".concat(prefixClass, "-spin");
  const spinWrapperClassName = "".concat(prefixClass, "-spin-wrap");
  const internalRowClassName = (record, index, indent) => {
    let mergeRowClassName;
    if (typeof rowClassName === 'function') {
      mergeRowClassName = rowClassName(record, index, indent);
    } else {
      mergeRowClassName = rowClassName;
    }
    return (0, _classnames.default)(mergeRowClassName, {
      noHover
    });
  };
  if (selection) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_selection.default, {
      dataSource: dataSource,
      rowKey: rowKey,
      selection: selection,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Table, {
        className: (0, _classnames.default)(baseClassName, className),
        style: style,
        pagination: false,
        dataSource: dataSource,
        rowKey: rowKey,
        showSorterTooltip: false,
        loading: {
          wrapperClassName: spinWrapperClassName,
          className: spinClassName,
          indicator: _spin.indicatorIcon,
          spinning: !!loading
        },
        locale: TableLocale.antdTableLocale,
        rowClassName: internalRowClassName
        // @ts-ignore
        ,
        columns: columns === null || columns === void 0 ? void 0 : columns.filter(i => i.hidden !== true).map(i => ({
          ...i,
          className: (0, _classnames.default)(i.className, {
            ["align-".concat(i.align)]: !!i.align
          })
        })),
        ...resizeableTable,
        ...restProps
      }, tableKey)
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Table, {
    className: (0, _classnames.default)(baseClassName, className),
    style: style,
    pagination: false,
    dataSource: dataSource,
    rowKey: rowKey,
    showSorterTooltip: false,
    loading: {
      wrapperClassName: spinWrapperClassName,
      className: spinClassName,
      indicator: _spin.indicatorIcon,
      spinning: !!loading
    },
    locale: TableLocale.antdTableLocale,
    rowClassName: internalRowClassName
    //@ts-ignore
    ,
    columns: resizeable ? resizeableTable.columns : columns === null || columns === void 0 ? void 0 : columns.filter(i => i.hidden !== true).map(i => ({
      ...i,
      className: (0, _classnames.default)(i.className, {
        ["align-".concat(i.align)]: !!i.align
      })
    })),
    ...resizeableTable,
    ...restProps
  }, tableKey);
}
function Table(props) {
  const {
    initing = false,
    ...otherTableProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_skeleton.default.Node, {
    loading: initing,
    block: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TableRender, {
      ...otherTableProps
    })
  });
}
var _default = exports.default = Table;